import { UiColors } from 'assets/styles/old/global';
import styled from 'styled-components';
import { DEVICES } from '_constants';

export const MapFeaturesWrapper = styled.div`
  #map-biglayerpanel-header,
  #map-biglayerpanel-togglebutton {
    background: ${UiColors.forestColor};
    color: ${UiColors.peachColor} !important;
  }

  .leaflet-biglayerpanel-header,
  .leaflet-biglayerpanel-header,
  .leaflet-biglayerpanel-accordion,
  .leaflet-biglayerpanel-control {
    width: 600px;
  }

  @media screen and (max-width: 767px) {
    .leaflet-biglayerpanel-header,
    .leaflet-biglayerpanel-header,
    .leaflet-biglayerpanel-accordion {
      max-width: 100%;
    }
  }
`;

export const MapFiltersWrapper = styled.div`
  padding: 20px 20px 0 20px;

  .table-filters {
    margin: 0;
    width: 100%;
  }
`;

export const ChipsWrapper = styled.div`
  width: calc(100% - 325px);
  margin: 0 0 24px;

  .chips_wrapper {
    padding: 0;
    margin-top: 10px;
    min-height: 100%;
    max-height: 150px;
    width: 580px;
    margin-top: 0;
    margin-bottom: 10px;

    @media ${DEVICES.tablet} {
      width: 100%;
      min-height: 30px;
      max-height: 120px;
    }

    button {
      font-size: 12px;
      height: 25px;
      margin: 0;
    }

    .chip,
    .chip_text,
    .chip_list_wrapper {
      font-size: 12px;
      height: 25px;
      line-height: 25px;
    }

    .chip_list_wrapper {
      gap: 7px;
      height: 100%;

      > div {
        margin: 0;
        line-height: 25px;
      }
    }
  }
`;

export const FilterWrapper = styled.div`
  margin: 0 0 15px;

  .form_search,
  .searchButton,
  .filter_button {
    height: 30px;
  }

  .search_icon {
    margin: 8px;
  }
`;

export const HideChipsButton = styled.button`
  display: flex;
  align-items: center;
  height: 30px;
  width: 100px;
  border: none;
  border-radius: 24px;
  padding-left: 6px;
  cursor: pointer;
  font-size: 12px;
  background: ${UiColors.forestColor};
  color: ${UiColors.peachColor};
  gap: 4px;
`;

export const ListViewButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  width: 120px;
  border: none;
  border-radius: 24px;
  cursor: pointer;
  font-size: 14px;
  text-decoration: underline;
  color: ${UiColors.focusColor};
  gap: 4px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 10px;

  width: 240px;
  button {
    :hover {
      filter: saturate(2);
    }
  }
`;

export const Panel = styled.div``;

export const SwatchLegendSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin-left: 15px;
`;

export const SwatchLegendWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`;

export const SwatchLegendsContainer = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 5px;
`;
